import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import ProxyLogin from "../views/proxyLogin.vue";
import Index from "../views/Index.vue";
import CompanyIndex from "../views/company/Index.vue";
import CompanyIdentity from "../views/company/Identity.vue";
import CompanyRole from "../views/company/Role.vue";
import CompanySetting from "../views/company/Setting.vue";
import AddRole from "../views/company/addRole.vue";
import EditRole from "../views/company/editRole.vue";
import AddNumber from "../views/company/addNumber.vue";
import EditNumber from "../views/company/editNumber.vue";
import BacthRole from "../views/company/bacthRole.vue";
import RoleAuthority from "../views/company/roleAuthority.vue";
import RoleAuthorityConsult from "../views/company/roleAuthorityConsult.vue";
import AdminSystem from "../views/company/adminSystem.vue"
import MongoList from "../views/company/mongoList.vue"
import ShardingSource from "../views/sharding/shardingSource.vue" //分库数据源
import Sharding from "../views/sharding/sharding.vue" //分库
import ShardingAdd from "../views/sharding/add.vue" //分库
import ShardingEdit from "../views/sharding/edit.vue" //分库
import ShardingSplit from "../views/sharding/split.vue" //分库拆分
import ServermMonitor from "../views/company/servermMonitor.vue"//服务器资源监控
import AddSystem from "../views/company/addSystem.vue";
import EditSystem from "../views/company/editSystem.vue";
import AdminMenu from "../views/company/adminMuenu.vue";
import AddMenu from "../views/company/addMenu.vue";
import EditMenu from "../views/company/editMenu.vue";
import RoleNumber from "../views/company/roleNumber.vue";
import AddRoleNumber from "../views/company/AddRoleNumber.vue";
import WebLog from "../views/company/webLog.vue";
import CalcSign from "../views/company/calcSign.vue";
import EditCalcSign from "../views/company/editCalcSign.vue";
import CalcSignShow from "../views/company/calcSignShow.vue";
import ImportHistory from "../views/company/importHistory.vue";
import { isNewVersion } from '@/utils/autoUpdate'

Vue.use(VueRouter);


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        title: '我的',
        requireAuth: true
      },
    },{
      path: "/proxyLogin",
      name: "ProxyLogin",
      component: ProxyLogin,
    },{
      path: "/company/index",
      name: "CompanyIndex",
      component: CompanyIndex,
      meta: {
        title: '公司信息',
        requireAuth: true
      },
    }, {
      path: "/company/identity",
      name: "CompanyIdentity",
      component: CompanyIdentity,
      meta: {
        title: '编号',
        requireAuth: true
      },
    },
    {
      path: "/company/role",
      name: "CompanyRole",
      component: CompanyRole,
      meta: {
        title: '角色设置',
        requireAuth: true
      },
    }, {
      path: "/company/setting",
      name: "CompanySetting",
      component: CompanySetting,
      meta: {
        title: '公司设置',
        requireAuth: true
      },
    }, {
      path: "/company/addRole",
      name: "AddRole",
      component: AddRole,
      meta: {
        title: '角色设置',
        requireAuth: true
      },
    }, {
      path: "/company/editRole",
      name: "EditRole",
      component: EditRole,
      meta: {
        title: '编辑角色',
        requireAuth: true
      },
    }, {
      path: "/company/addNumber",
      name: "AddNumber",
      component: AddNumber,
      meta: {
        title: '添加编号',
        requireAuth: true
      },
    }, {
      path: "/company/editNumber",
      name: "EditNumber",
      component: EditNumber,
      meta: {
        title: '编辑编号',
        requireAuth: true
      },
    },
    {

      path: "/company/bacthRole",
      name: "BacthRole",
      component: BacthRole,
      meta: {
        title: '批量修改角色',
        requireAuth: true
      },
    },
    {
      path: "/company/roleAuthority",
      name: "RoleAuthority",
      component: RoleAuthority,
      meta: {
        title: '权限设置',
        requireAuth: true
      },
    },
    {
      path: "/company/roleAuthorityConsult",
      name: "RoleAuthorityConsult",
      component: RoleAuthorityConsult,
      meta: {
        title: '权限设置参考',
        requireAuth: true
      },
    },
    {
      // 系统管理列表
      path: "/company/adminSystem",
      name: "AdminSystem",
      component: AdminSystem,
      meta: {
        title: '系统管理',
        requireAuth: true
      },
    },
    {
      // 系统管理列表
      path: "/company/mongoList",
      name: "MongoList",
      component: MongoList,
      meta: {
        title: 'mongo库列表',
        requireAuth: true
      },
    },
    // ShardingSource from "../views/company/shardingSource.vue" //分库数据源
    // import Sharding fro
    {
      // 分库数据源
      path: "/sharding/shardingSource",
      name: "ShardingSource",
      component: ShardingSource,
      meta: {
        title: '数据源管理',
        requireAuth: true
      },
    },
    {
      // 分库
      path: "/sharding/sharding",
      name: "Sharding",
      component: Sharding,
      meta: {
        title: '数据分库',
        requireAuth: true
      },
    },
    {
      // 分库
      path: "/sharding/add",
      name: "ShardingAdd",
      component: ShardingAdd,
      meta: {
        title: '新建项目',
        requireAuth: true
      },
    },
    {
      path: "/sharding/edit",
      name: "ShardingEdit",
      component: ShardingEdit,
      meta: {
        title: '编辑项目',
        requireAuth: true
      },
    },
    {
      path: "/sharding/split",
      name: "ShardingSplit",
      component: ShardingSplit,
      meta: {
        title: '拆分项目',
        requireAuth: true
      },
    },
    {
      // 系统管理列表
      path: "/company/servermMonitor",
      name: "ServermMonitor",
      component: ServermMonitor,
      meta: {
        title: '服务器资源监控',
        requireAuth: true
      },
    },
    {
      // 添加系统
      path: "/company/addSystem",
      name: "AddSystem",
      component: AddSystem,
      meta: {
        title: '添加系统',
        requireAuth: true
      },
    },
    {
      // 编辑系统
      path: "/company/editSystem",
      name: "EditSystem",
      component: EditSystem,
      meta: {
        title: '编辑系统',
        requireAuth: true
      },
    },
    {
      path: "/company/adminMenu",
      name: "AdminMenu",
      component: AdminMenu,
        meta: {
          title: '菜单管理',
          requireAuth: true
        },
    },
    {
      path: "/company/addMenu",
      name: "AddMenu",
      component: AddMenu,
        meta: {
          title: '添加功能菜单',
          requireAuth: true
        },
    },
    {
      path: "/company/editMenu",
      name: "EditMenu",
      component: EditMenu,
        meta: {
          title: '编辑菜单',
          requireAuth: true
        },
    },
    {
      path: "/company/roleNumber",
      name: "RoleNumber",
      component: RoleNumber,
        meta: {
          title: '角色编号菜单',
          requireAuth: true
        },
    },
    {
      path: "/company/AddRoleNumber",
      name: "AddRoleNumber",
      component: AddRoleNumber,
      meta: {
        title: '编号(角色)',
        requireAuth: true
      },
    },
    {
      path: "/company/webLog",
      name: "WebLog",
      component: WebLog,
      meta: {
        title: 'webLog日志',
        requireAuth: true
      },
    },
    {
      path: "/company/calcSign",
      name: "CalcSign",
      component: CalcSign,
      meta: {
        title: '指数符号列表',
        requireAuth: true
      },
    },
    {
      path: "/company/calcSignShow",
      name: "CalcSignShow",
      component: CalcSignShow,
      meta: {
        title: '指数符号详情',
        requireAuth: true
      },
    },
    {
      path: "/company/editCalcSign",
      name: "EditCalcSign",
      component: EditCalcSign,
      meta: {
        title: '编辑指数符号',
        requireAuth: true
      },
    },
    {
      path: "/company/importHistory",
      name: "ImportHistory",
      component: ImportHistory,
      meta: {
        title: '编号导入历史',
        requireAuth: true
      }
    },
    {
      path: "/about",
      name: "About",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ "../views/About.vue"),
    },
  ]
})
router.beforeEach((to, from, next) => {
  isNewVersion()
  next()
})
export default router;